import InformationCircle from "../assets/svg/information-circle.svg?react";
import styled, { css } from "styled-components";
import { Trans } from "@coworker/locales";
import { BlueLink } from "./Link";
import { ElidedText } from "@coworker/reusable/components/ElidedText";

const extraCSS = css`
  margin: 24px 24px 24px 22px;
  width: 70%;
`;

const StyledInformationCircle = styled(InformationCircle)`
  color: var(--blue-medium);
  width: 14px;
  height: 14px;
  aspect-ratio: 1 / 1;
`;

const StyledElidedText = styled(ElidedText)`
  text-align: left;
`;

const Subtext = styled("div")`
  color: var(--grey718);
  font-weight: normal;
`;

/**
 * @param {{ relatedTasksCount:number|"", ofWhichClosed?:number|"",productId:string, i18nKey?:string }}
 */
export function RelatedTasksLink({
  relatedTasksCount,
  ofWhichClosed,
  productId,
  i18nKey,
}) {
  if (!relatedTasksCount) return null;

  const to = relatedTasksCount ? `/tasks/related/${productId}` : "";

  const relatedTaskInformationText = i18nKey ? (
    i18nKey
  ) : (
    <Trans count={relatedTasksCount}>relatedTasksCountString</Trans>
  );
  return (
    <>
      <StyledInformationCircle />
      <BlueLink addon css={extraCSS} to={to}>
        <StyledElidedText>
          {ofWhichClosed && ofWhichClosed !== relatedTasksCount ? (
            <>
              {relatedTaskInformationText}
              <Subtext>
                <Trans count={ofWhichClosed}>ofWhichRecentlyClosedString</Trans>
              </Subtext>
            </>
          ) : ofWhichClosed ? (
            <Trans count={ofWhichClosed}>onlyRecentlyClosedString</Trans>
          ) : (
            relatedTaskInformationText
          )}
        </StyledElidedText>
      </BlueLink>
    </>
  );
}
